import React from "react";
import { Routes, Route } from "react-router-dom";
import Calculator from "./components/Calculator";
import Results from "./components/Results";
import NavBar from "./components/NavBar";
import ErrorBoundary from "./ErrorBoundary";
import HomePage from "./components/HomePage";
import "./App.css";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import NextSteps from "./components/NextSteps";
import ProjectInfo from "./components/ProjectInfo";
import ProjectEstimator from "./components/ProjectEstimator";
import Next2Steps from "./components/Next2Steps";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { ToastProvider } from "./components/ui/toast";
import Footer from "./components/Footer";
import Verify from "./components/Verify";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Checkout from "./components/Checkout";
import RegisterApplicator from "./components/RegisterApplicator";
import { CartProvider } from "./context/CartContext";
import Next3Steps from "./components/Next3Steps";
import ProjectList from "./components/ProjectList";
import { UnitSystemProvider } from "./context/UnitSystemContext";
import ReviewPage from "./components/ReviewPage";
import { ProjectIdProvider } from "./context/ProjectIdContext";
import { ProjectInfoProvider } from "./context/ProjectInfoContext";
import { ApplicatorProvider } from "./context/ApplicatorContext";
import ScrollToTop from "./components/ScrollToTop";
import PendingApproval from "./components/PendingApproval";
import Dashboard from "./components/admin/Dashboard";
import { UserIdProvider } from "./components/admin/UserIdContext";
import { UserTypeProvider } from "./context/UserTypeContext";
import ContactForm from "./components/ContactForm";

// Suppress validateDOMNesting warnings temporarily
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === "string" && args[0].includes("validateDOMNesting")) {
    return; // Suppress the warning
  }
  originalError(...args);
};

const App = () => {
  return (
    <ErrorBoundary>
      <UserTypeProvider>
        <ProjectInfoProvider>
          <ApplicatorProvider>
            <ProjectIdProvider>
              <UserIdProvider>
                <ToastProvider>
                  <AuthProvider>
                    <CartProvider>
                      <UnitSystemProvider>
                        <ScrollToTop />
                        <div className="tw-mx-3 sm:tw-mx-10 md:tw-mx-24 lg:tw-mx-44 tw-scrollbar-hide">
                          <NavBar />
                          <div className="tw-mt-40  md:tw-mt-44 ">
                            <Routes>
                              <Route
                                path="/admin"
                                element={
                                  <ProtectedRoute>
                                    <Dashboard />
                                  </ProtectedRoute>
                                }
                              />

                              <Route path="/" element={<HomePage />} />
                              <Route
                                path="/register"
                                element={<RegisterApplicator />}
                              />
                               <Route
                                path="/contactus"
                                element={<ContactForm />}
                              />
                              <Route
                                path="/pendingapproval"
                                element={<PendingApproval />}
                              />
                              <Route
                                path="/reviewapplicator/:id"
                                element={<ReviewPage />}
                              />
                              <Route
                                path="/reviewapplicator"
                                element={<ReviewPage />}
                              />
                              <Route path="/signin" element={<SignIn />} />
                              <Route path="/signup" element={<SignUp />} />
                              <Route path="/verify" element={<Verify />} />
                              <Route
                                path="/forgotpassword"
                                element={<ForgotPassword />}
                              />
                              <Route
                                path="/resetpassword"
                                element={<ResetPassword />}
                              />
                              <Route
                                path="/resetpassword/:token"
                                element={<ResetPassword />}
                              />
                              <Route
                                path="/nextsteps"
                                element={<NextSteps />}
                              />
                              <Route
                                path="/checkout"
                                element={
                                  <ProtectedRoute>
                                    <Checkout />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/projectlist"
                                element={
                                  <ProtectedRoute>
                                    <ProjectList />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/projectinfo"
                                element={
                                  <ProtectedRoute>
                                    <ProjectInfo />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/calculator"
                                element={
                                  <ProtectedRoute>
                                    <Calculator />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/designsummary"
                                element={
                                  <ProtectedRoute>
                                    <Results />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/nextsteps2"
                                element={<Next2Steps />}
                              />
                              <Route
                                path="/projectestimator"
                                element={
                                  <ProtectedRoute>
                                    <ProjectEstimator />
                                  </ProtectedRoute>
                                }
                              />
                              <Route
                                path="/nextsteps3"
                                element={<Next3Steps />}
                              />
                            </Routes>
                          </div>
                          <Footer />
                        </div>
                      </UnitSystemProvider>
                    </CartProvider>
                  </AuthProvider>
                </ToastProvider>
              </UserIdProvider>
            </ProjectIdProvider>
          </ApplicatorProvider>
        </ProjectInfoProvider>
      </UserTypeProvider>
    </ErrorBoundary>
  );
};

export default App;
